import React, { useState } from "react";

const NewUpload = ({ accept, error, children, multiple, fileName, onchange, fileInputDisabled, uploadTextClassName = "mt-3 mb-3 block text-xl", minWidth = "40%" }) => {
    const [isDragging, setIsDragging] = useState(false);

    const handleDragOver = (e) => {
        e.preventDefault();
        setIsDragging(true);
    };

    const handleDragLeave = () => {
        setIsDragging(false);
    };

    const handleDrop = (e) => {
        e.preventDefault();
        setIsDragging(false);

        if (onchange) {
            // mimic file input event
            const files = e.dataTransfer.files;
            onchange({ target: { files } });
        }
    };

    return (
        <div>
            <div className="grid justify-content-center">
                <div
                    className={`flex m-3 flex-column align-items-center border-1 border-dashed border-round-md cursor-pointer border-700`}
                    style={{ padding: "1rem", minWidth: minWidth, backgroundColor: isDragging ? "#d1ccba" : "#E5E1CF" }}
                    onDragOver={handleDragOver}
                    onDragLeave={handleDragLeave}
                    onDrop={handleDrop}
                >
                    <div className="fileUpload text-center">
                        <div className="text-6xl mb-2">
                            <i className="pi pi-file" style={{ fontSize: "3rem", color: "#9AAB89" }}></i>
                        </div>
                        <div className="text-lg font-Gerstner-ProgramRegular">{fileName ?? ""}</div>
                        <div className="w-full flex justify-content-center">
                            <span className="font-Gerstner-ProgramRegular" style={{ color: "#333" }}>
                                Drag and Drop File here
                            </span>
                        </div>

                        <div className="my-1 font-Gerstner-ProgramRegular" style={{ color: "#333" }}>
                            Or
                        </div>
                        <div className="font-semibold underline cursor-pointer font-Gerstner-ProgramRegular">Browse & Select</div>
                        <input type="file" value="" className="upload" multiple={multiple} onChange={onchange} accept={accept} disabled={fileInputDisabled} />
                    </div>

                    {children}

                    {error ? (
                        <>
                            <br />
                            <span className="color5">{error}</span>
                        </>
                    ) : null}
                    <br />
                </div>
            </div>
        </div>
    );
};

export default NewUpload;
